import { useGetSharesSummary } from "hooks/shares";
import "./CompaniesSummary.scss";
import { useEffect, useMemo, useState } from "react";

const BASE_CURRENCY = "PLN";

const CompaniesSummary = () => {
  const { data: summary } = useGetSharesSummary();

  const [selectedCurrency, setSelectedCurrency] =
    useState<string>(BASE_CURRENCY);

  const availableCurrencies = useMemo(() => {
    if (!summary) {
      return [BASE_CURRENCY];
    }

    const keys = Object.keys(summary).filter(
      (key) => key !== "combined" && key !== BASE_CURRENCY
    );

    const preferredOrder = ["EUR", "USD"];

    const orderedPreferred = preferredOrder.filter((c) => keys.includes(c));
    const otherCurrencies = keys
      .filter((c) => !preferredOrder.includes(c))
      .sort();

    return [BASE_CURRENCY, ...orderedPreferred, ...otherCurrencies];
  }, [summary]);

  const currentTotalValue = useMemo(() => {
    if (!summary) return 0;

    const currencySummary = summary[
      selectedCurrency as keyof typeof summary
    ] as { totalValue?: number } | undefined;

    if (!currencySummary) return 0;

    return currencySummary.totalValue ?? 0;
  }, [summary, selectedCurrency]);

  const handleCurrencyClick = (currency: string) => {
    setSelectedCurrency(currency);
  };

  const currencyLabel = useMemo(() => {
    if (selectedCurrency === BASE_CURRENCY) return "zł";
    if (selectedCurrency === "EUR") return "€";
    if (selectedCurrency === "USD") return "$";
    return selectedCurrency;
  }, [selectedCurrency]);

  useEffect(() => {
    if (!availableCurrencies.includes(selectedCurrency)) {
      setSelectedCurrency(BASE_CURRENCY);
    }
  }, [availableCurrencies, selectedCurrency]);

  return (
    <div className="summary">
      <div className="summary__container">
        <div className="summary__header">
          <h3>Portfel</h3>
          {availableCurrencies.length > 1 && (
            <div className="summary__currencies">
              {availableCurrencies.map((currency) => (
                <button
                  key={currency}
                  type="button"
                  className={
                    currency === selectedCurrency
                      ? "summary__currency-tab summary__currency-tab--active"
                      : "summary__currency-tab"
                  }
                  onClick={() => handleCurrencyClick(currency)}
                >
                  {currency}
                </button>
              ))}
            </div>
          )}
        </div>
        <p>
          {currentTotalValue}{" "}
          <span className="summary__currency">{currencyLabel}</span>
        </p>
      </div>
      <div className="summary__container">
        <h3>Ilość zakupionych spółek</h3>
        <p>{summary?.combined?.totalCount ?? 0}</p>
      </div>
    </div>
  );
};

export default CompaniesSummary;
